import api from '../index'

export default {

    /**
     * Get
     * @param params
     */
    get(params) {
        return api
            .get(`/billing/invoices`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Show
     * @param invoice
     * @param params
     */
    show(invoice, params) {
        return api
            .get(`/billing/invoices/${invoice}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Delete
     * @param invoice
     */
    delete(invoice) {
        return api
            .delete(`/billing/invoices/${invoice}`)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get lines
     * @param invoice
     * @param params
     */
    getLines(invoice, params) {
        return api
            .get(`/billing/invoices/${invoice}/lines`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Get credit notes linked to an invoice
     * @param invoice
     * @param params
     */
    getCreditNotes(invoice, params) {
        return api
            .get(`/billing/invoices/${invoice}/credit-notes`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Set invoice as paid
     * @param invoice
     */
    setPaid(invoice) {
        return api
            .post(`/billing/invoices/${invoice}/pay`)
            .then(response => {
                return response.data
            })
    },

    /**
     * Start payment
     * @param invoice
     * @param params
     */
    pay(invoice, params) {
        return api
            .get(`/billing/invoices/${invoice}/pay`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Download PDF
     * @param invoice
     * @param params
     */
    download(invoice, params) {
        return api
            .get(`/billing/invoices/${invoice}/download`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Finalize invoice
     * @param invoice
     * @param data
     */
    finalize(invoice, data) {
        return api
            .post(`/billing/invoices/${invoice}/finalize`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Send by mail
     * @param invoice
     * @param data
     */
    mail(invoice, data) {
        return api
            .post(`/billing/invoices/${invoice}/sendMail`, data)
            .then(response => {
                return response.data
            })
    }

}
